import { useState } from 'react'
import qs from 'qs'
import dayjs from 'dayjs'
import { useQuery } from 'react-query'

import { getJSON } from 'common/services/api'
import DashboardFilters, {
  PerAssessmentFilters,
} from './components/DashboardFilters/DashboardFilters'
import DashboardBody from './components/DashboardBody/DashboardBody'
import { PerAssessmentResponse } from '@lmc/ts-common'

export const initialFiltersValue: PerAssessmentFilters = {
  rangePicker: [dayjs().subtract(12, 'month'), dayjs()],
  residents: [],
  riskAssessment: null,
}

export const generateApiUrl = (filterParams: PerAssessmentFilters) => {
  const { riskAssessment, residents, rangePicker } = filterParams

  const queryStr = qs.stringify({
    formId: riskAssessment,
    residents,
    from: rangePicker?.[0]?.toISOString(),
    to: rangePicker?.[1]?.toISOString(),
  })

  return `/api/list/risk-assessments/dashboard/per-assessment?${queryStr}`
}

const PerAssessmentScreen = (): JSX.Element => {
  const [filterParams, setFilterParams] =
    useState<PerAssessmentFilters>(initialFiltersValue)
  const url = generateApiUrl(filterParams)

  const { isLoading, data } = useQuery<PerAssessmentResponse>(url, () =>
    getJSON({ url })
  )

  return (
    <>
      <DashboardFilters onChange={setFilterParams} value={filterParams} />
      <DashboardBody
        data={data}
        filterParams={filterParams}
        isLoading={isLoading}
      />
    </>
  )
}

export default PerAssessmentScreen
